import { SvgIcon, type SvgIconProps } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

export const makeSvgIcon =
  (svg: ReactNode): React.FC<SvgIconProps> =>
  (props) => <SvgIcon {...props}>{svg}</SvgIcon>;
